import type { State, Action } from './typings'
import { setActiveRequirementProducer } from './actions'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'setActiveRequirement':
      return setActiveRequirementProducer(state, action.payload)
  }
}

/**
 * set active: { open? }
 * close
 * closed
 */
